<template>
  <BaseFieldContainer>
    <VeeField
      name="hostUserId"
      :modelValue="hostUserId"
      v-slot="{ errors }"
    >
      <label
        for="hostUserText"
      >
        Voice Profile
      </label>
      <small id="hostUserId-help">
        Choose the voice profile that will be used to read ads.
      </small>
      <InputGroup>
        <InputText
          id="hostUserText"
          class="bg-white"
          :style="{
            color: '#334155'
          }"
          :modelValue="selectedHostUsername"
          disabled
          aria-describedby="hostUserId-help"
        />
        <Button
          v-if="canEditHostUserId"
          label="Choose"
          @click="onChooseClick"
        />
        <Button
          v-else-if="!canEditHostUserId && selectedHostUserOption"
          label="Edit Voice"
          @click="onEditClick"
        />
      </InputGroup>
      <small
        v-if="errors.length > 0"
        class="text-red-400"
      >
        {{ errors[0] }}
      </small>
    </VeeField>
  </BaseFieldContainer>

  <WarningMessage v-if="showNoHostUserWarning">
    You must add a voice profile to the podcast
    before your podcast can start receiving ad campaigns.
  </WarningMessage>
  <WarningMessage v-if="showHostUserHasNoVoiceWarning">
    The voice profile you have chosen does not have a voice configured.
    You must configure a voice before your podcast can start receiving ad campaigns.
  </WarningMessage>

  <UserListSidebar
    v-model:visible="isSidebarVisible"
    :hostUserId="hostUserId"
    :hostUserOptions="hostUserOptions"
    @update:hostUserId="$emit('update:hostUserId', $event)"
  />

  <VoiceProfileSidebar
    v-model:visible="editVoiceProfileSidebar.visible"
    :user="editVoiceProfileSidebar.user"
    @selectUserId="(userId) => $emit('update:hostUserId', userId)"
  />
</template>

<script>
import UserListSidebar from './components/userListSidebar';
import VoiceProfileSidebar from './components/voiceProfileSidebar';

export default {
  components: {
    UserListSidebar,
    VoiceProfileSidebar,
  },
  props: {
    hostUserId: {
      validator: (prop) => typeof prop === 'number' || prop === null,
    },
    hostUserOptions: {
      type: Array,
      default: () => ([]),
    },
    canEditHostUserId: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showNoHostUserWarning() {
      return !this.hostUserId;
    },
    showHostUserHasNoVoiceWarning() {
      if (!this.hostUserId) {
        return false;
      }
      const matchingUser = this.hostUserOptions.find((option) => option.value === this.hostUserId);
      return !!matchingUser && !matchingUser.user.voice_id;
    },
    selectedHostUserOption() {
      const matchingHostUserOption = this.hostUserOptions
        .find((item) => item.value === this.hostUserId);

      if (!matchingHostUserOption) {
        return null;
      }

      return matchingHostUserOption;
    },
    selectedHostUsername() {
      return this.selectedHostUserOption
        ? this.selectedHostUserOption.label
        : '';
    },
  },
  data() {
    return {
      isSidebarVisible: false,
      editVoiceProfileSidebar: {
        visible: false,
        user: null,
      },
    };
  },
  methods: {
    onChooseClick() {
      this.isSidebarVisible = true;
    },
    onEditClick() {
      if (this.selectedHostUserOption) {
        this.editVoiceProfileSidebar.visible = true;
        this.editVoiceProfileSidebar.user = this.selectedHostUserOption.user;
      }
    },
  },
};
</script>
